<template>
  <div class="icon-container" :class="{ 'spinner': loading, pointer }">
    <suspense>
      <template #default>
        <mdi-icon 
          :icon="loading ? 'mdiLoading' : iconValue" 
          :size="iconSize" 
          :style="{ 'color': iconColor }" 
          preserveAspectRatio="xMidYMid meet"
        />
      </template>
    </suspense>
  </div>
</template>

<script lang="ts" setup>
// INTERFACES

interface IconProps {
  icon: Icons;
  size?: Size;
  color?: string;
  loading?: boolean;
  pointer?: boolean;
}

// PROPS

const props = withDefaults(defineProps<IconProps>(), {
  size: 'small',
  color: 'base-icon',
});

// CONSTANTS

const sizes = {
  'x-small': '16px',
  small: '20px',
  medium: '24px',
  large: '28px',
};

// COMPUTEDS

const iconSize = computed(() => sizes[props.size]);

const iconColor = computed(() => resolvedColor(props.color));

const iconValue = computed(() => replaceIconName(props.icon));

// METHODS

const replaceIconName = (icon: Icons): Icons => {
  if (!icon || typeof icon !== 'string' || !icon.includes('mdi')) return '' as Icons;
  if (!icon.includes('-')) return icon;

  return icon
    .split('-')
    .map((word: string, index: number) => index === 0 ? word : capitalize(word))
    .join('') as Icons;
}

</script>

<style scoped>
.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}
.icon-container.pointer {
  cursor: pointer;
}
.spinner {
  animation: rotate 2s linear infinite;
  transform-origin: center;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
</style>
